import { createMuiTheme } from '@material-ui/core/styles';
import LamanteShell from 'src/components/site/shells/LamanteShell';
import { coreSiteRoutes } from 'src/config/sites/coreRoutes';
import { createModuleInit } from './moduleInit';
import { SiteDefinition } from './SiteDefinition';

const acmeSite: SiteDefinition = {
    id: 'acme',
    label: 'Acme Site',
    description: 'Acme customer experience',
    hostnames: ['acme.localhost', 'acme.example.com'],
    routes: coreSiteRoutes,
    shell: LamanteShell,
    init: createModuleInit(),
    theme: outerTheme =>
        createMuiTheme(outerTheme, {
            palette: {
                primary: { main: '#0b911d' },
            },
        }),
};

export default acmeSite;
